import Vue from 'vue';
import App from './App';
import router from './router';
import { getUserInfo, getLocationInfo, systemInfo } from '@/utils/util';
import mixin from '@/utils/mixin';
import { c_dynamicSetFontSize } from '@didi/gpux-utils';

import {
  Style,
  Form,
  Button,
  Popup,
  Radio,
  Textarea,
  Checkbox,
  Tip,
  CheckboxGroup,
  Upload
} from 'cube-ui';
import dialog from '@/components/ui/dialog/index';
import { runtime } from '@/utils/runtime';

import {
  UsageFeedback,
  ContactCustomerService,
  Faq
} from '@didi/kfss-components';

Vue.use(Style);
Vue.use(Form);
Vue.use(Button);
Vue.use(Radio);
Vue.use(Textarea);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Popup);
Vue.use(Tip);
Vue.use(Upload);

Vue.component(ContactCustomerService.name, ContactCustomerService);
Vue.component(UsageFeedback.name, UsageFeedback);
Vue.component(Faq.name, Faq);
Vue.mixin(mixin);

Vue.config.productionTip = false;
Vue.config.devtools = 'source-map';
c_dynamicSetFontSize();
const setUpApp = async res => {
  console.log('set up APP: ', res);
  let sys_info = {}
  try {
    sys_info = await systemInfo()
  } catch (error) {
    console.log(error)
  }
  const info = {
    data() {
      return {
        Mixin_User_Info: res,
        Mixin_System_Info: sys_info
      };
    }
  };
  Vue.mixin(info);
  new Vue({
    el: '#app',
    router,
    render: h => h(App)
  });
};
// eslint-disable-next-line one-var
const getSetUpData = time => {
  return new Promise((resolve, reject) => {
    let tokenState = false;
    // eslint-disable-next-line one-var
    let localInfo = window.sessionStorage.getItem('acceptor_local_cache');
    // eslint-disable-next-line one-var
    let data = {};
    // 设置定时器
    const tid = setTimeout(() => {
      if (!tokenState) {
        if (localInfo) {
          try {
            data = JSON.parse(localInfo);
            tokenState = true;
          } catch (error) {
            console.log(error);
          }
        }
        reject(data);
      }
    }, time);
    getUserInfo()
      .then(res => {
        clearTimeout(tid);
        tokenState = true;
        data = res;
        resolve(data);
      })
      .catch(err => {
        console.log(err);
        reject(data);
      });
    getLocationInfo()
      .then(res => {
        window.city_id_from_location = res && res.city_id;
      })
      .catch(err => {
        console.log(err);
      });
  });
};

dialog.loading({
  desc: '加载中...',
  timeout: 99999
});

if (
  runtime.is('app') ||
  runtime.is('didies') ||
  runtime.is('kflowerPassenger')
) {
  getSetUpData(2000)
    .then(data => {
      try {
        window.sessionStorage.setItem(
          'acceptor_local_cache',
          JSON.stringify(data || {})
        );
      } catch (error) {
        console.log(error);
      }
      setUpApp(data);
    })
    .catch(err => {
      console.log('捕获错误: ', err);
      setUpApp(err);
    });
} else {
  setUpApp({});
}
